export enum AptPartnerships {
    NO_PARTNERSHIP = 'N',
    FASTWEB = 'FASTWEB',
}
